"use client";

import { LayoutGroup } from "framer-motion";
import type { ReactNode } from "react";

export function GuidesMotionLayout({ children }: { children: ReactNode }) {
  return <LayoutGroup id="guides-articles">{children}</LayoutGroup>;
}
